// extracted by mini-css-extract-plugin
module.exports = {"lia-user-status-container":"BanMessageBanner_lia-user-status-container__fIKAK"};